const TOOL_DISPLAY_NAMES: Record<string, string> = {
  todo_read: "Read todos",
  todo_write: "Update todos",
  issue_list: "List issues",
  issue_read: "Read issue",
  issue_create: "Create issue",
  issue_update: "Update issue",
  issue_comment_create: "Add comment",
  wiki_read: "Read wiki page",
  wiki_glob: "Search wiki files",
  wiki_grep: "Search wiki content",
  wiki_apply_patch: "Edit wiki page",
  file_list: "List files",
  file_read: "Read file",
  file_write: "Write file",
  question: "Ask question",
  activate_skill: "Activate skill",
}

export function getToolDisplayName(name: string): string {
  return TOOL_DISPLAY_NAMES[name] || name
}
